// import {v4 as uuid } from 'uuid';
async function sync (params) {
    const {
        calendar = 'desktop',
    } = params;

    console.log('sync() -> ', calendar);
    // window.weblog(`syncStore.sync() syncing... ${calendar}`);
    const syncFunc = this.getSyncFunc(calendar);
    if (typeof syncFunc === 'function') {
        await syncFunc(params);
    }
}

export function getSyncFunc (calendar) {
    const funcs = this.getSyncFuncs();
    if (funcs[calendar]) {
        return funcs[calendar];
    }
    return this.syncDesktop;
}

export default sync;
